import React, { Component } from "react";

class FormContact extends Component {
  render() {
    return (
      <div className="col-md-6">
        <div className="themesflat-headings style-2 clearfix">
          <h2 className="heading">KONTAKT FORMA</h2>
          <div className="sep has-width w80 accent-bg clearfix" />
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={36}
          data-mobile={35}
          data-smobile={35}
        />
        <div className="themesflat-contact-form style-2 clearfix">
          <div style={{ width: "140%", marginLeft: "-20%" }}>
            <iframe
              name="monday"
              id="monday"
              src="https://forms.monday.com/forms/embed/7cc237e58c0ecd887220080936dbb0aa?r=use1"
              width="100%"
              height="1100px"
            ></iframe>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default FormContact;
